import './user-menu.scss';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import { Dispatch, SetStateAction } from 'react';

function UserMenu({
    open,
    setOpen
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}) {
    const params: any = useParams();
    const user = useSelector((state: RootState) => state.user);
    
    return (
        <ul id="user-menu" className={open ? 'open' : ''}>
            <i className="fas fa-user"></i>
            <p>{user?.Name} {user?.Surname}</p>
            {params.clientId && <Link to="/clients"><li onClick={() => setOpen(false)}>Clients</li></Link>}
            {params.clientId && <Link to={`/client/${params.clientId}/calendar`}><li onClick={() => setOpen(false)}>Calendar</li></Link>}
            <li className="logout"><Link to="/login">Logout</Link></li>
        </ul>
    )
}

export default UserMenu;